import { AuthGuard } from './../login/AuthGuard/auth.guard';
import { LayoutsComponent } from './../components/layouts/layouts.component';
import { NgModule } from '@angular/core';
import { CommonModule,DatePipe } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ChartsModule } from 'ng2-charts';
import { MenuLeftComponent } from './menu-left/menu-left.component';
import { UserService } from './user/user.service';
import { SalesService } from './sales-forecast/sales-service.service';
import { StoreService } from './store-view/store-service.service';
import { LoaderService } from './loader/loader.service';
import { SummaryComponent } from './sales-forecast/summary.component';
import { ChartModule} from 'angular-highcharts';
import { UserComponent } from './user/user.component';
import { AppService } from '../app.service';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MomentModule } from 'angular2-moment';
import { StoreViewComponent } from './store-view/store-view.component';
import { AgmCoreModule } from '@agm/core';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { LoaderComponent } from './loader/loader.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';


@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    ChartsModule,
    NgbTooltipModule.forRoot(),
    MomentModule,
    ChartModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBTz_LaytcM5O6n6LhIJdjPmCvek_mLO_w',
      libraries: ["places"]
    }),
    AgmJsMarkerClustererModule,
    MultiselectDropdownModule,
    AngularMultiSelectModule,
    
  ],
  declarations: [
    SummaryComponent,
    UserComponent,
    StoreViewComponent,
    LoaderComponent,
  ],
  providers: [ LoaderService,UserService, SalesService,AppService,StoreService,DatePipe]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// ./src/app/home-page/dashboards.module.ts